/* Página de marca Mondraker · Pidiendo Pista */
(function(){
  if(window.mdkLoaded)return;window.mdkLoaded=true;
  function initNav(root){
    var b=root.querySelector('.mdk-burger'),m=root.querySelector('.mdk-mobile');
    if(!b||!m||b.dataset.ready)return;b.dataset.ready=1;
    b.addEventListener('click',function(){m.hidden=!m.hidden;b.setAttribute('aria-expanded',!m.hidden)});
  }
  function initCarousel(root){
    var track=root.querySelector('.mdk-track');if(!track||track.dataset.ready)return;track.dataset.ready=1;
    var cards=[].slice.call(track.querySelectorAll('.mdk-card')),dots=root.querySelector('.mdk-dots'),
        details=[].slice.call(root.querySelectorAll('.mdk-detail')),sel=0;
    cards.forEach(function(c,i){
      var d=document.createElement('button');d.type='button';d.setAttribute('aria-label',c.dataset.name||('Modelo '+(i+1)));
      d.addEventListener('click',function(){select(i,true)});dots&&dots.appendChild(d);
      c.addEventListener('click',function(){select(i,false)});
    });
    function select(i,scroll){
      sel=i;
      cards.forEach(function(c,j){c.setAttribute('aria-pressed',j===i)});
      dots&&[].forEach.call(dots.children,function(d,j){d.setAttribute('aria-current',j===i)});
      details.forEach(function(d,j){d.hidden=j!==i});
      if(scroll){track.scrollTo({left:cards[i].offsetLeft-track.offsetLeft,behavior:'smooth'})}
    }
    var p=root.querySelector('.mdk-arrow.prev'),n=root.querySelector('.mdk-arrow.next');
    p&&p.addEventListener('click',function(){select((sel-1+cards.length)%cards.length,true)});
    n&&n.addEventListener('click',function(){select((sel+1)%cards.length,true)});
    if(cards.length)select(0,false);
    window.mdkSelectModel=function(name){
      var i=cards.findIndex(function(c){return (c.dataset.name||'').toLowerCase()===String(name).toLowerCase()});
      if(i>-1){track.closest('.mdk').scrollIntoView({behavior:'smooth'});select(i,true)}
    };
  }
  function initDealers(root){
    var f=root.querySelector('.mdk-filters');if(!f||f.dataset.ready)return;f.dataset.ready=1;
    var items=[].slice.call(root.querySelectorAll('.mdk-dealer')),cities=['Todas'];
    items.forEach(function(d){if(cities.indexOf(d.dataset.city)<0)cities.push(d.dataset.city)});
    cities.forEach(function(c){
      var b=document.createElement('button');b.type='button';b.textContent=c;
      b.addEventListener('click',function(){
        items.forEach(function(d){d.hidden=!(c==='Todas'||d.dataset.city===c)});
        [].forEach.call(f.children,function(x){x.setAttribute('aria-pressed',x===b)});
      });f.appendChild(b);
    });
    f.firstChild&&f.firstChild.setAttribute('aria-pressed','true');
  }
  function initPanels(root){
    [].forEach.call(root.querySelectorAll('[data-model]'),function(a){
      a.addEventListener('click',function(e){if(window.mdkSelectModel){e.preventDefault();window.mdkSelectModel(a.dataset.model)}});
    });
  }
  function init(root){root=root||document;initNav(root);initCarousel(root);initDealers(root);initPanels(root)}
  document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
